/* TangTalk：文章目录（2026-10-09 起替代站点代码注入里的 tocbot 目录）
   - 桌面（≥1200px）：正文左侧的吸附目录，高亮当前小节，只展开当前大节的小标题
   - 手机 / 平板：正文第一个标题前放一个可折叠的「本文目录」；往下读之后顶部出现一条
     「当前小节」细条，点开是底部弹出的完整目录（不再用左下角浮动按钮，那里是 AI 客服）
   - 标题层级按文章实际用到的来定：只用 h1 当小节的老文章也有目录
   - 跳过卡片 / 付费墙 / 商品卡里的标题，以及「超人气教程」「推荐阅读」这类文末推广区块
   - 保留 Ghost 自带的标题 id，分享出去的 #锚点 链接不会失效 */
(function () {
    if (!document.body.classList.contains('post-template')) return;
    const content = document.querySelector('.gh-content');
    if (!content) return;

    const MIN_ITEMS = 3;
    const DESKTOP = window.matchMedia('(min-width: 1200px)');
    // 文末推广 / 致谢区块：标题本身和它下面的小标题都不进目录
    const SKIP_TEXT = /超人气教程|参考资料|合作伙伴|推荐阅读|相关阅读|相关教程|延伸阅读|往期回顾|热门教程/;
    // 卡片和主题自己插入的区块里的标题不算正文结构
    const SKIP_INSIDE = '.kg-card, .tt-paywall, .gh-post-upgrade-cta, [class^="tt-"], [class*=" tt-"], aside, blockquote';

    // 函数写在用到之前：构建时的压缩会把后面声明的函数改成变量，提前调用就报错
    const levelOf = function levelOf(h) {
        return Number(h.tagName.charAt(1));
    };

    const all = Array.from(content.querySelectorAll('h1, h2, h3, h4')).filter(function (h) {
        // 只看正文以内的区块：<html> 上也可能有 tt- 开头的类名（公告栏占位的 .tt-ann）
        const box = h.parentElement.closest(SKIP_INSIDE);
        return !(box && content.contains(box)) && h.textContent.trim() !== '' && h.offsetParent !== null;
    });
    if (!all.length) return;

    // 最高层级 + 下一级进目录（h4 多半是加粗小提示，只有文章最高就到 h3 时才算第二级）
    const top = Math.min.apply(null, all.map(levelOf));
    const sub = top + 1;

    const items = [];
    let skipBelow = 0; // 正在跳过的推广区块的层级
    all.forEach(function (h) {
        const level = levelOf(h);
        if (level > sub) return;
        if (skipBelow && level > skipBelow) return;
        skipBelow = 0;
        const text = h.textContent.replace(/\s+/g, ' ').trim();
        if (SKIP_TEXT.test(text)) {
            skipBelow = level;
            return;
        }
        items.push({ el: h, text: text, depth: level === top ? 0 : 1 });
    });
    if (items.length < MIN_ITEMS) return;

    // 每个标题都要有不重复的 id；Ghost 生成的 id 原样保留
    const used = new Set();
    items.forEach(function (item, i) {
        let id = item.el.id;
        if (!id || used.has(id)) {
            id = 'toc-' + (i + 1);
            item.el.id = id;
        }
        used.add(id);
    });

    // 每个大节记住自己有没有小标题，桌面端只展开当前大节
    let parent = null;
    items.forEach(function (item) {
        if (item.depth === 0) {
            parent = item;
            item.children = 0;
        } else if (parent) {
            parent.children++;
            item.parent = parent;
        }
    });

    function buildList(withSub) {
        const ol = document.createElement('ol');
        ol.className = 'tt-toc-list';
        items.forEach(function (item, i) {
            if (!withSub && item.depth) return;
            const li = document.createElement('li');
            li.className = 'tt-toc-item' + (item.depth ? ' is-sub' : '');
            li.dataset.index = i;
            const a = document.createElement('a');
            a.href = '#' + item.el.id;
            a.textContent = item.text;
            li.appendChild(a);
            ol.appendChild(li);
        });
        ol.addEventListener('click', function (e) {
            const a = e.target.closest('a');
            if (!a) return;
            e.preventDefault();
            go(items[Number(a.parentElement.dataset.index)]);
        });
        return ol;
    }

    // 跳转：滚动距离交给标题上的 scroll-margin-top（CSS），地址栏换成这个小节的锚点方便分享
    function go(item) {
        closeSheet();
        item.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + item.el.id);
    }

    const majors = items.filter(function (item) { return !item.depth; }).length;

    /* 1. 正文里的「本文目录」（手机 / 平板） */
    const inline = document.createElement('details');
    inline.className = 'tt-toc-inline';
    const summary = document.createElement('summary');
    summary.innerHTML = '<b>本文目录</b><span>' + majors + ' 节</span>';
    inline.appendChild(summary);
    inline.appendChild(buildList(false));
    items[0].el.parentNode.insertBefore(inline, items[0].el);

    /* 2. 桌面侧栏 */
    const side = document.createElement('nav');
    side.className = 'tt-toc-side';
    side.setAttribute('aria-label', '文章目录');
    side.innerHTML = '<div class="tt-toc-head">目录</div>';
    const sideList = buildList(true);
    side.appendChild(sideList);
    document.body.appendChild(side);

    /* 3. 手机顶部当前小节条 + 底部弹出目录 */
    const bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'tt-toc-bar';
    bar.setAttribute('aria-label', '打开文章目录');
    bar.innerHTML = '<span class="tt-toc-bar-label">目录</span><span class="tt-toc-bar-text"></span><span class="tt-toc-bar-icon" aria-hidden="true"></span><i class="tt-toc-bar-progress"></i>';
    document.body.appendChild(bar);
    const barText = bar.querySelector('.tt-toc-bar-text');
    const barProgress = bar.querySelector('.tt-toc-bar-progress');

    const sheet = document.createElement('div');
    sheet.className = 'tt-toc-sheet';
    sheet.innerHTML = '<div class="tt-toc-sheet-panel" role="dialog" aria-label="文章目录"><div class="tt-toc-sheet-head"><b>本文目录</b><button type="button" class="tt-toc-sheet-close" aria-label="关闭">×</button></div></div>';
    const sheetPanel = sheet.firstChild;
    const sheetList = buildList(true);
    sheetPanel.appendChild(sheetList);
    document.body.appendChild(sheet);

    function openSheet() {
        sheet.classList.add('is-open');
        document.documentElement.classList.add('tt-toc-locked');
        const active = sheetList.querySelector('.is-active');
        if (active) active.scrollIntoView({ block: 'center' });
    }

    function closeSheet() {
        sheet.classList.remove('is-open');
        document.documentElement.classList.remove('tt-toc-locked');
    }

    bar.addEventListener('click', openSheet);
    sheet.addEventListener('click', function (e) {
        if (e.target === sheet || e.target.closest('.tt-toc-sheet-close')) closeSheet();
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSheet();
    });

    /* 4. 滚动时：当前小节高亮、侧栏 / 顶部条的显示时机 */
    let current = -1;
    let ticking = false;

    function update() {
        ticking = false;
        const offset = 120;
        let index = -1;
        for (let i = 0; i < items.length; i++) {
            if (items[i].el.getBoundingClientRect().top - offset <= 0) index = i;
            else break;
        }

        const box = content.getBoundingClientRect();
        const inContent = box.top < 0 && box.bottom > window.innerHeight * 0.5;
        const pastInline = inline.getBoundingClientRect().bottom < 0;
        side.classList.toggle('is-visible', DESKTOP.matches && box.top < window.innerHeight * 0.6 && box.bottom > window.innerHeight * 0.4);
        bar.classList.toggle('is-visible', !DESKTOP.matches && inContent && pastInline);
        const read = Math.min(1, Math.max(0, -box.top / (box.height - window.innerHeight)));
        barProgress.style.transform = 'scaleX(' + read + ')';

        if (index === current) return;
        current = index;
        [sideList, sheetList].forEach(function (list) {
            list.querySelectorAll('.is-active, .is-open').forEach(function (li) {
                li.classList.remove('is-active', 'is-open');
            });
        });

        const item = items[index];
        barText.textContent = item ? item.text : items[0].text;
        if (!item) return;
        const major = item.depth ? item.parent : item;
        [sideList, sheetList].forEach(function (list) {
            const li = list.querySelector('[data-index="' + index + '"]');
            li.classList.add('is-active');
            // 当前大节的小标题展开
            if (major) list.querySelectorAll('.tt-toc-item').forEach(function (el) {
                const it = items[Number(el.dataset.index)];
                if (it === major || it.parent === major) el.classList.add('is-open');
            });
        });
        // 侧栏很长时，让当前项保持在侧栏可见范围内
        const activeSide = sideList.querySelector('.is-active');
        if (activeSide && side.scrollHeight > side.clientHeight) {
            const r = activeSide.getBoundingClientRect();
            const s = side.getBoundingClientRect();
            if (r.top < s.top + 40 || r.bottom > s.bottom - 40) {
                side.scrollTop += r.top - s.top - s.height / 3;
            }
        }
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.body.classList.add('has-tt-toc');
    update();
})();
